import React from 'react';
import { useCookies } from 'react-cookie';
import { useLocation, Navigate } from 'react-router';
import { NOSH_AUTH_DATA_KEY } from '../config/Keys';

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectPath?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectPath = '/',
}) => {
  const [cookies] = useCookies();
  const location = useLocation();

  if (cookies[NOSH_AUTH_DATA_KEY]) {
    return <>{children}</>;
  }

  return <Navigate to={redirectPath} state={{ from: location }} replace />;
};

export default ProtectedRoute;
